import { render, staticRenderFns } from "./kr-radio-multiple.vue?vue&type=template&id=32390cbd&scoped=true&"
import script from "./kr-radio-multiple.vue?vue&type=script&lang=js&"
export * from "./kr-radio-multiple.vue?vue&type=script&lang=js&"
import style0 from "./kr-radio-multiple.vue?vue&type=style&index=0&id=32390cbd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32390cbd",
  null
  
)

export default component.exports